import { render, staticRenderFns } from "./PaihMigratorSettings.vue?vue&type=template&id=7f0d0c62&scoped=true&"
import script from "./PaihMigratorSettings.vue?vue&type=script&lang=js&"
export * from "./PaihMigratorSettings.vue?vue&type=script&lang=js&"
import style0 from "./PaihMigratorSettings.vue?vue&type=style&index=0&id=7f0d0c62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0d0c62",
  null
  
)

export default component.exports